// extracted by mini-css-extract-plugin
module.exports = {"container":"profile-avatar_container__CdweS","round":"profile-avatar_round__Or1Hm","vip-tag":"profile-avatar_vip-tag__rEKEi"};